import React from "react";
import "./testimonials.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import {
  FaReact,
  FaHtml5,
  FaBootstrap,
  FaNodeJs,
  FaGitAlt,
  FaGithub,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiJavascript,
  SiMongodb,
  SiMysql,
  SiFirebase,
  SiSequelize,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";

const Testimonials = () => {
  return (
    <section className="mx-6" id="testimonials">
      <Carousel
        infiniteLoop
        useKeyboardArrows
        showArrows
        autoPlay
        centerMode
        showStatus={false}
        showThumbs={false}
        centerSlidePercentage={20}
        className=""
      >
        <div className="flex flex-col items-center w-48">
          <FaHtml5 size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            HTML5
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <DiCss3 size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            CSS3
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <SiJavascript size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            JAVASCRIPT
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <FaReact size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2  font-bold sub-text">
            REACT
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <SiTailwindcss size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            TAILWINDCSS
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <FaBootstrap size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            BOOTSTRAP
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <FaGitAlt size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            GIT
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <FaGithub size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            GITHUB
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <FaNodeJs size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            NODEJS
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <SiMongodb size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            MONGODB
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <SiMysql size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            MYSQL
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <SiSequelize size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            SEQUELIZE
          </h5>
        </div>

        <div className="flex flex-col items-center w-48">
          <SiFirebase size={50} />
          <h5 className="text-xs md:text-md lg:text-lg pt-2 font-bold sub-text">
            FIREBASE
          </h5>
        </div>
      </Carousel>
    </section>
  );
};

export default Testimonials;
